import React, { useEffect, useState } from "react";
import TableContainer from "../../components/table/table-container";
import Button from "../../components/buttons/button";
import { useNavigate } from "react-router-dom";
import Pagination from "../../components/pagination/pagination";
import search from "../../assets/icons/searchIcon.svg";
import EditInventoryModal from "../../components/modals/inventory/edit-inventory-modal";
import { errorToast, successToast } from "../../components/notifications/toast";
import { deleteInventoryAction, inventoryListAction } from "../../redux/actions/inventoryAction";
import { useDispatch } from "react-redux";
import Loader from "../../components/loaders/dot-loader";

const Inventory = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setSearchValue] = useState('');
    const [debouncedValue, setDebouncedValue] = useState("");
    const [paginationData, setPaginationData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [inventoryItems, setInventoryItems] = useState([])
    const [modalVisible, setModalVisible] = useState(false);
    const [productDetails, setProductDetails] = useState({});

    const handlePageChange = (page) => {
        setCurrentPage(page);
        console.log("Current Page:", page);
    };

    const handleEdit = (product) => {
        setProductDetails(product)
        setModalVisible(true)
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(searchValue);
            setCurrentPage(1)
        }, 300);

        return () => {
            clearTimeout(handler);
        };
    }, [searchValue]);

    useEffect(() => {
        fetchProducts()
    }, [currentPage, debouncedValue])

    const fetchProducts = () => {
        setLoading(true)
        dispatch(inventoryListAction({ page: currentPage, search: debouncedValue, page_size: 10 }, onSuccess, onError))
    }


    const onSuccess = (data) => {
        setInventoryItems(data.data.data.inventory);
        setPaginationData(data.data.data.pagination)
        setLoading(false)
    }

    const onError = (data) => {
        const errorMsg = data.data.message || "Unable to fetch try later";
        errorToast(errorMsg)
        setLoading(false)
    }

    const handleDelete = (id) => {
        setLoading(true)
        dispatch(deleteInventoryAction({ id }, (data) => { successToast(data.data.message); fetchProducts(); setLoading(false) }, onError))
    };

    return (
        <TableContainer>
            <div className="flex flex-col sm:flex-row justify-between px-2 pb-2 w-full">
                <div className="w-full sm:w-auto">
                    {/* Bread crumb data */}
                    <div
                        style={{ height: "2.5rem" }}
                        className={`input_border flex items-center rounded-md w-full sm:w-auto mx-1 md:w-80`}
                    >
                        <span className="px-2">
                            <img width={"16px"} src={search} alt="search icon" />
                        </span>
                        <input
                            placeholder={`Search here`}
                            className="table_search_input w-full rounded-md fs_12 placeholder:text-fs_12"
                            type="text"
                            value={searchValue}
                            onChange={(e) => {
                                setSearchValue(e?.target?.value);
                            }}
                        />
                        <span className='fs_14 mx-3 cursor-pointer text-primary' onClick={() => setSearchValue('')} >Clear</span>
                    </div>
                </div>

                <div className="w-full sm:w-auto mt-2 sm:mt-0 flex gap-2">
                    <Button onClick={() => navigate('/inventory/stock-inflow')} variant="primary" size="md" className="w-full sm:w-auto">
                        Add New Stock
                    </Button>
                    <Button onClick={() => navigate('/inventory/stock-return')} variant="primary" size="md" className="w-full sm:w-auto">
                        Update Return
                    </Button>
                </div>
            </div>

            <div className="relative">
                <div className="overflow-auto border border-gray-300 rounded-md" style={{ height: '45rem' }}>
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="bg-gray-100 sticky top-0">
                                <th className="p-2 border border-gray-200 font-medium text-left">#</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Code</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Image</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Product Name</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Category</th>
                                <th className="p-2 border border-gray-200 font-medium ">Uom</th>
                                <th className="p-2 border border-gray-200 font-medium">Available Stock</th>
                                <th className="p-2 border border-gray-200 font-medium">PTS</th>
                                <th className="p-2 border border-gray-200 font-medium">PTR</th>
                                <th className="p-2 border border-gray-200 font-medium">MRP</th>
                                <th className="p-2 border border-gray-200 font-medium">Batch Number</th>
                                <th className="p-2 border border-gray-200 font-medium">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="12" style={{ height: '35rem' }}>
                                        <Loader />
                                    </td>
                                </tr>
                            ) : inventoryItems.length > 0 ? inventoryItems.map((product, index) => (
                                <tr key={product.id} className="hover:bg-gray-50">
                                    <td className="p-2 border border-gray-200">{(currentPage - 1) * paginationData?.pageSize + (index + 1)}</td>
                                    <td className="px-2 border border-gray-200 text-left">{product?.product?.code}</td>
                                    <td className="px-2 border border-gray-200">
                                        {product?.product?.image ?
                                            <img
                                                src={product?.product?.image}
                                                alt={product?.product?.name}
                                                className="w-16 h-14 object-cover rounded-md truncate"
                                            />
                                            : <div className="py-2">--</div>
                                        }
                                    </td>
                                    <td className="p-2 border border-gray-200 text-left">{product?.product?.name}</td>
                                    <td className="p-2 border border-gray-200 text-left">{product?.product?.category?.name}</td>
                                    <td className="p-2 border border-gray-200">{product?.uom}</td>
                                    <td className="p-2 border border-gray-200">{product?.quantity}</td>
                                    <td className="p-2 border border-gray-200">{product?.pts}</td>
                                    <td className="p-2 border border-gray-200">{product?.ptr}</td>
                                    <td className="p-2 border border-gray-200">{product?.mrp}</td>
                                    <td className="p-2 border border-gray-200">{product?.batch_number ?? "--"}</td>
                                    <td className="px-2 border border-gray-200 text-center">
                                        <button
                                            onClick={() => handleEdit(product)}
                                            className="text-blue-500 hover:underline"
                                        >
                                            Edit
                                        </button>
                                        <button
                                            onClick={() => handleDelete(product?.id)}
                                            className={`hover:underline mx-2 text-red-600`}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            )) :
                                <tr>
                                    <td colSpan="12" style={{ height: '35rem' }}>
                                        <span className="text-gray-400 font-extralight"> No Data Found</span>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="flex justify-end mt-2 bottom-0 right-0">
                <Pagination
                    totalPages={paginationData?.totalPages}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />
            </div>
            <EditInventoryModal
                isOpen={modalVisible}
                onClose={() => setModalVisible(false)}
                product={productDetails}
                reload={fetchProducts}
            />
        </TableContainer>
    );
};

export default Inventory;
